import React from "react";
import PropTypes from "prop-types";
import ButtonGroup from "../../ButtonGroup";
import dictionary from "../../../../dictionary";

import styles from "../button-group.module.scss";

function Clothes(props) {
  const {name, content, onChange, current} = props;
  return (
    <div className={styles.root}>
      <ButtonGroup
        current={current}
        buttons={content}
        onChange={(value) => onChange(name, value)}
        renderButton={({value, difference}) => (
          <span className={styles.value}>
            {dictionary.item[value]}
            {` `}
            {value !== current && difference && (
              <span className={styles.difference}>
                {difference > 0 && `+`}
                {difference}₽
              </span>
            )}
          </span>
        )}
      />
      <span className={styles.label}>– выберите материал</span>
    </div>
  );
}

Clothes.propTypes = {
  productName: PropTypes.string,
  department: PropTypes.string,
  category: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      difference: PropTypes.number
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func
};

export default Clothes;
